import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Slider() {
  const images = [
    "/images/Mask group (1).png",
    "/images/Mask group (2).png",
    "/images/Mask group (3).png",
    "/images/Mask group (4).png",
    "/images/Mask group (5).png",
    "/images/Mask group (6).png",
    // "/images/Mask group (7).png",
    "/images/Mask group (1).png",
    "/images/Mask group (2).png",
    "/images/Mask group (3).png",
    "/images/Mask group (4).png",
    "/images/Mask group (5).png",
    "/images/Mask group (6).png",
    // "/images/Mask group (7).png",
    "/images/Mask group (1).png",
    "/images/Mask group (2).png",
    "/images/Mask group (3).png",
    "/images/Mask group (4).png",
    "/images/Mask group (5).png",
    "/images/Mask group (6).png",
    // "/images/Mask group (7).png",/
    "/images/Mask group (1).png",
    "/images/Mask group (2).png",
    "/images/Mask group (3).png",
    "/images/Mask group (4).png",
    "/images/Mask group (5).png",
    "/images/Mask group (6).png",
    // "/images/Mask group (7).png",
    "/images/Mask group (1).png",
    "/images/Mask group (2).png",
    "/images/Mask group (3).png",
    "/images/Mask group (4).png",
    "/images/Mask group (5).png",
    "/images/Mask group (6).png",
    // "/images/Mask group (7).png",
    "/images/Mask group (1).png",
    "/images/Mask group (2).png",
    "/images/Mask group (3).png",
    "/images/Mask group (4).png",
    "/images/Mask group (5).png",
    "/images/Mask group (6).png",
    // "/images/Mask group (7).png",
    "/images/Mask group (1).png",
    "/images/Mask group (2).png",
    "/images/Mask group (3).png",
    "/images/Mask group (4).png",
    "/images/Mask group (5).png",
    "/images/Mask group (6).png",
    // "/images/Mask group (7).png",
  ];

  return (
    // <div className="slider-container">
    <div className="slider">
      <div className="slide-track">
        {[...images, ...images].map((src, index) => (
          <div key={index} className="slide">
            <img src={src} alt="slide" />
          </div>
        ))}
      </div>
      {/* </div> */}
      <style jsx>{`
        .slider-container {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100vh;
          background: #e3e3e3;
        }
        .slider {
          background: rgba(255, 255, 255, 0.05);
          //   box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.125);
          height: 100px;
          margin: auto;
          overflow: hidden;
          position: relative;
          //   width: 960px;
        }
        .slider::before,
        .slider::after {
          content: "";
          position: absolute;
          width: 200px;
          height: 100px;
          z-index: 2;
          //   background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
        }
        .slider::after {
          right: 0;
          top: 0;
          transform: rotateZ(180deg);
        }
        .slider::before {
          left: 0;
          top: 0;
        }
        .slide-track {
          display: flex;
          animation: scroll 40s linear infinite;
          width: calc(250px * 14);
          align-items: baseline;
          justify-content: center;
        }
        .slide {
          height: 100px;
          width: 250px;
        }
        .slide img {
          width: 250px;
        }
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(calc(-250px * 7));
          }
        }
      `}</style>
    </div>
  );
}
